import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { io } from 'socket.io-client';

@Component({
  selector: 'app-header-landing',
  templateUrl: './header-landing.component.html',
  styleUrls: ['./header-landing.component.css']
})
export class HeaderLandingComponent implements OnInit {

  socket: any;
  constructor(public services: ApiService) { }

  ngOnInit(): void {
    // this.socket = io('https://ogc.mapedia.co.th/api/v2/lrfund/');
  }
  onClick() {
    const clickData = {
      branch: "guest",
      username: ""
    }
    // this.services.create('m_countofuser', clickData).then((res: any) => {
    //   this.services.get('m_countofuser').then((res:any)=>{
    //     //this.socket.emit('output', res)
    //   })
    // })
  }

}
